import { useState, useEffect } from 'react';
import { getEmailsByWorkspace } from 'wisestep-api';

import { IAggregation } from '../../types';
import { IMISAnalyticsQuery } from '../IMISAnalyticsQuery';

import AnalyticsTableWith2ConstantColumns from './AnalyticsTableWith2ConstantColumns';

const EmailsByAllWorkspacesTable = ({ query, duration }: IMISAnalyticsQuery) => {
  const [aggregatedData, setAggregatedData] = useState<IAggregation[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getEmailsByWorkspace(query);
      setAggregatedData(response.data.aggregations.aggregation.buckets);
    };
    fetchData();
  }, [query]);

  return (
    <AnalyticsTableWith2ConstantColumns
      data={aggregatedData}
      title={`Emails sent from Platform in ${duration ?? 'Last 8 weeks - Weekly'}`}
      loadAllWorkspacesData={query.loadAllWorkspacesData}
    />
  );
};
export default EmailsByAllWorkspacesTable;
